/**
 * @file IconSearchTwo Icon
 * @author Auto Generated by @polyv/icons-cli
 */

import { IconBuilder } from '@polyv/icons-vue/icon-builder';

export default IconBuilder(
  'icon-search-two',
  (data) => `
<svg width="${data.size}" height="${data.size}" fill="none" viewBox="0 0 70 70">
  <defs>
    <clipPath><rect width="70" height="70" x="0" y="0" rx="0" /></clipPath>
  </defs>
  <g clip-path="url(#master_svg0_1_05361)">
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        d="M34.99823296875,13.078125C34.11226296875,13.078125,33.39404296875,13.796345,33.39404296875,14.682315C33.39404296875,15.568285,34.11226296875,16.286505,34.99823296875,16.286505C42.63643296875,16.286505,48.82844296875,22.478485,48.82844296875,30.116725C48.82964296875,31.001825,49.54754296875,31.718625,50.43264296875,31.718625C51.31774296875,31.718625,52.03554296875,31.001825,52.03684296875,30.116725C52.041142968749995,20.707835,44.41144296875,13.078125,34.99823296875,13.078125Z"
      />
    </g>
    <g>
      <path
        fill="${data.colorDesc[0]}"
        fill-opacity="1"
        d="M68.995683984375,65.5144796875L57.182683984375,53.7013796875C73.022783984375,35.3662796875,63.929183984375,6.7689296875,40.408483984375,0.9499226875C16.887683984375,-4.8690803125,-4.490606015625,16.1894796875,0.973315984375,39.7952796875C6.437253984375,63.4009796875,34.894283984375,72.9244796875,53.466083984375,57.3624796875L65.306883984375,69.2032796875C66.320183984375,70.2521796875,67.996583984375,70.2665796875,69.027783984375,69.2353796875C70.058983984375,68.2040796875,70.044583984375,66.5277796875,68.995683984375,65.5144796875ZM32.551983984375,59.3597796875C17.711083984375,59.3267796875,5.707163984375,47.2683796875,5.741543984375,32.4273796875C5.775923984375,17.5863796875,17.835483984375,5.5836996875,32.676483984375,5.6195196875C47.517483984375,5.6553396875,59.518983984375,17.7160796875,59.481783984375,32.5570796875C59.444483984375,47.3939796875,47.388883984375,59.3926796875,32.551983984375,59.3597796875Z"
      />
    </g>
  </g>
</svg>
`
);
